export type FavouritePendingAction = "add" | "remove" | null;

export const FAVOURITE_SAVE_CONFIRMATION =
  "Saved to Companion. PeakWave will watch the conditions here.";

export const FAVOURITE_BUTTON_TOUCH_TARGET_CLASS = "min-h-[44px]";

export function favouriteButtonLabel(input: {
  isLoggedIn: boolean;
  favourited: boolean;
  pendingAction: FavouritePendingAction;
  /** The unsaved label on a designed surface ("Save", "Save Taghazout"), signed in or not. */
  saveLabel?: string;
}): string {
  if (!input.isLoggedIn) return input.saveLabel ?? "Sign up to save";
  if (input.pendingAction === "remove") return "Removing";
  if (input.pendingAction === "add") return "Saving";
  return input.favourited ? "Saved to Companion" : input.saveLabel ?? "Save to Companion";
}
